import {createSelector} from '@reduxjs/toolkit';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {Playlist} from '../../api/types';

export const selectFavorites = createSelector(
    [(state: RootState) => state.favorites],
    (slice) => slice.playlists,
);

export const selectFavoritesList = createSelector(
    [selectFavorites],
    (playlists): Playlist[] => Object.values(playlists),
);

export const selectIsFavorite = createSelector(
    [selectFavorites, (_state: RootState, id: string) => id],
    (playlists, id): boolean => !!playlists[id],
);

export const useFavorites = () => useSelector(selectFavoritesList);

export const useIsFavorite = (id: string) =>
    useSelector((state: RootState) => selectIsFavorite(state, id));
